import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import shuffleArray from "shuffle-array";
import Swal from "sweetalert2";
import "swiper/css"; //basic
import "swiper/css/navigation";
import "swiper/css/pagination";
import owari from "../assets/sound/finish/owari.mp3";
import startPlaySound from "../assets/sound/start/startPlay.mp3";
import threeSecond from "../assets/sound/time/3second.mp3";
import fiveSecond from "../assets/sound/time/5second.mp3";
import sevenSecond from "../assets/sound/time/7second.mp3";
import finalHudaIs from "../assets/sound/time/finalHudaIs.mp3"
import CustomBottomSetting from "../component/CustomBottomSetting";
import CustomBottomSheet from "../component/CustomBottomSheet";
import { setFalse, setTrue } from "../features/bgm/BgmSlice";
import "../pages/PlayPageAuto.css";

const PlayPageAuto = ({ customHudaList, play }) => {
    const dispatcher = useDispatch();
    const isWide = useMediaQuery({ query: "(min-width: 600px)" });
    let waitTime = null;
    const [maxIndex, setMaxIndex] = useState(0);
    const [hudaIndex, setHudaIndex] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const [onCountdownStart, setOnCountdownStart] = useState(false);


    const [customSetting, setCustomSetting] = useState({
        cardNum: 46,
        repeatCount: 2,
        interval: 3,
        speed: 1,
    });
    const [newHudaList, setNewHudaList] = useState(setRandomHudaList(customHudaList));
    const setWaitTime = () => {
        if (hudaIndex === newHudaList.length - 1) {
            return finalHudaIs;

        } else {
            if (customSetting.interval === 3) {
                return threeSecond;
            } else if (customSetting.interval === 5) {
                return fiveSecond;
            } else {
                return sevenSecond;
            }
        }
    };
    const waitTimeSound = setWaitTime();
    const [isKarutaSound, setIsKarutaSound] = useState(true);
    const [isOpen, setOpen] = useState(false);
    const [isSettingOpen, setSettingOpen] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const isPlayingRef = useRef(false);
    const repeatRef = useRef(0);
    const soundRef = useRef();
    const secondTimeRef = useRef();
    const playStartRef = useRef();

    const owariRef = useRef();
    const [showEhuda, setShowEhuda] = useState(false);
    const [openModal, setOpenModal] = useState(true);
    const [playStart, setPlayStart] = useState(false);
    const [skeleton, setSkeleton] = useState(true);
    const [isHome, setIsHome] = useState(true);
    const isHeight = useMediaQuery({ query: "(min-height: 620px)" });
    const handleModalOpen = () => {
        setOpenModal(true);
    };
    const handleModalClose = () => {
        setPlayStart(true);
        setOpenModal(false);
    };
    useEffect(() => {
        startPlay();
    }, []);

    const betweenSameIntreval = 1000;
    const reSettingKaruta = (setting) => {
        setCustomSetting({
            cardNum: setting.cardNum,
            repeatCount: setting.repeatCount,
            interval: setting.interval,
            speed: setting.speed,
        });
        setHudaIndex(0);
        setMaxIndex(0);
        setIsPlaying(false);
        setIsKarutaSound(true);
        setShowEhuda(false);
        setOpen(false);
        waitTimePause();
        soundPause();
        owariPause();
        if (waitTime != null) {
            clearTimeout(waitTime);
        }
    };

    function timeout(delay) {
        return new Promise((res) => setTimeout(res, delay));
    }
    function setRandomHudaList(list) {
        var mList = shuffleArray.pick(list, { picks: customSetting.cardNum });
        mList.forEach((e) => {
            var newAudio = new Audio(e.sound);
            newAudio.addEventListener("loadedmetadata", (e2) => {
                e.duration = e2.target.duration;
            });
            newAudio.remove();
            newAudio.srcObject = null;
            newAudio.src = "";
        });
        return mList;
    }


    useEffect(() => {
        setNewHudaList(setRandomHudaList(customHudaList));
        setIsPlaying(false);
        setIsKarutaSound(true);
        repeatRef.current = 0;
        soundRef.current.current = 0;
        setShowEhuda(false);
        if (waitTime != null) {
            clearTimeout(waitTime);
        }
        waitTimePause();
    }, [customSetting]);
    useEffect(() => {
        try {
            if (isPlaying) {
                playStartRef.current.pause();
                dispatcher(setFalse());
                if (isKarutaSound) {
                    soundPlay();
                } else {
                    waitTimePlay();
                }
            } else {
                if (waitTime != null) {
                    clearTimeout(waitTime);
                }
                if (isKarutaSound) {
                    soundPause();
                } else {
                    waitTimePause();
                }
                dispatcher(setTrue());
            }
        } catch (e) {
            console.log(e);
        }
    }, [isPlaying, hudaIndex]);
    useEffect(() => {
        isPlayingRef.current = isPlaying;
    }, [isPlaying]);
    function soundPlay() {
        const playPromise = soundRef.current.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    }
    function startPlay() {
        const playPromise = playStartRef.current.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    }

    async function owariPlay() {
        await timeout(1500);
        const playPromise = owariRef.current.play();
        setIsPlaying(false);
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    }
    async function owariPause() {
        owariRef.current.pause();
    }

    function soundPause() {
        soundRef.current.pause();
    }
    function waitTimePlay() {
        const playPromise = secondTimeRef.current.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => { }).catch((error) => { });
        }
    }
    async function waitTimePause() {
        secondTimeRef.current.pause();
    }

    async function customOnEnded() {
        try {
            if (repeatRef.current < customSetting.repeatCount - 1) {
                waitTime = await timeout(3000);
                repeatRef.current = repeatRef.current + 1;
                if (isPlayingRef.current == false) {
                    soundPause();
                } else {
                    soundPlay();
                }
            } else {
                if (hudaIndex < newHudaList.length - 1) {
                    await timeout(betweenSameIntreval);
                    setIsKarutaSound(false);
                    setShowEhuda(true);
                    waitTimePlay();
                } else {
                    await timeout(betweenSameIntreval);
                    setIsKarutaSound(false);
                    setShowEhuda(true);
                    waitTimePlay();
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
    const onCircleComplete = () => {
        setSkeleton(true);
        setShowEhuda(false);
        if (hudaIndex == maxIndex) {
            setMaxIndex(maxIndex + 1);
        }
        if (hudaIndex >= newHudaList.length - 1) {
            setIsKarutaSound(false);
            setShowEhuda(true);
            owariPlay();
            gameFinished();
            setHudaIndex(0);
            setMaxIndex(0);
            setIsPlaying(false);
            setIsKarutaSound(true);
            setShowEhuda(false);
            setOpen(false);
            waitTimePause();
            soundPause();
            owariPause();
            dispatcher(setTrue());
            if (waitTime != null) {
                clearTimeout(waitTime);
            }
            repeatRef.current = 0;
        } else {
            setHudaIndex(hudaIndex + 1);
            setIsKarutaSound(true);
            repeatRef.current = 0;
        }

    };
    const gameFinished = () => {
        const modal = Swal.fire({
            title: "数えてね！",
            icon: "success",
            confirmButtonColor: "#3085d6", //빨간색
            confirmButtonText: "はい",
        }).then((result) => {

        });
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <audio src={owari} ref={owariRef} loop={false}></audio>
            <audio src={waitTimeSound} ref={secondTimeRef} loop={false} onEnded={onCircleComplete}></audio>
            <audio src={startPlaySound} ref={playStartRef} loop={false}></audio>
            {newHudaList != null && (
                <audio
                    src={newHudaList[hudaIndex].sound}
                    ref={soundRef}
                    loop={false}
                    onEnded={customOnEnded}
                    onCanPlay={() => {
                        soundRef.current.playbackRate = customSetting.speed;
                    }}
                ></audio>
            )}
            <div className={isWide ? "head-bar-wide" : "head-bar"}>
                <IconButton
                    onClick={() => {
                        dispatcher(setTrue());
                        play();
                        reSettingKaruta(customSetting);
                        navigate("/", {
                            state: {
                                cardNum: customSetting.cardNum,
                                repeatCount: customSetting.repeatCount,
                                interval: customSetting.interval,
                                speed: customSetting.speed,
                            },
                        });
                    }}
                >
                    <HomeIcon className={isWide ? "home-button-wide" : "home-button"} />
                </IconButton>

                <span style={{ display: "flex", alignItems: "center", fontSize: isWide ? "3rem" : "2rem", color: "rgb(228, 158, 74)", fontWeight: "700" }}>
                    {hudaIndex + 1}/{newHudaList.length}
                </span>

                <IconButton
                    onClick={() => {
                        play();
                        setSettingOpen(true);
                    }}
                >
                    <SettingsIcon className={isWide ? "home-button-wide" : "home-button"} ></SettingsIcon>
                </IconButton>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                    style={{
                        display: !showEhuda ? "block" : "none",
                        width: "100%",
                        position: "absolute",
                        top: "45%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                >
                    <button
                        className={isPlaying ? "pulse-button play" : "pulse-button pause"}
                        style={{ width: isWide ? "20rem" : "15rem", height: isWide ? "20rem" : "15rem" }}
                        onClick={() => {
                            if (isPlaying) {
                                setIsPlaying(false);
                                if (waitTime != null) {
                                    clearTimeout(waitTime);
                                }
                            } else {
                                setIsPlaying(true);
                            }
                        }}
                    >
                        <span style={{ fontWeight: "700" }}>{isPlaying ? "ストップ" : "スタート"}</span>
                    </button>
                </div>
                <div
                    style={{
                        display: showEhuda ? "block" : "none",
                        width: "100%",
                        marginTop: "1rem"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                        }}
                    >
                        <div
                            style={
                                skeleton
                                    ? {
                                        display: "flex",
                                        height: "45vh",
                                        width: "70%",
                                        margin: "auto",
                                    }
                                    : { display: "none" }
                            }
                        >
                            <CircularProgress style={{ width: "6rem", height: "6rem", margin: "auto", color: "rgb(247, 205, 154)" }} />
                        </div>

                        <img
                            className="answer-image-auto"
                            src={newHudaList[hudaIndex].eHuda}
                            loading="eager"
                            onLoad={() => {
                                setSkeleton(false);
                            }}
                            style={!skeleton ? {} : { display: "none", maxHeight: isHeight ? "40vh !important" : "35vh !important" }}
                            alt="今、プレイされる札のイメージ"
                        />
                    </div>
                    <div
                        style={{
                            color: "red",
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            fontSize: isHeight ? "2rem" : "1.5rem",
                            fontWeight: "600",
                        }}
                    >
                        これが せいかい！！
                    </div>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    position: "fixed",
                    bottom: isWide ? "5rem" : "2.5rem",
                    width: isWide ? "60%" : "100%",
                    justifyContent: "space-around",
                }}
            >
                <IconButton
                    onClick={() => {
                        play();
                        if (hudaIndex != 0) {
                            setHudaIndex(hudaIndex - 1);
                            repeatRef.current = 0;
                            setIsPlaying(true);
                        }
                    }}
                >
                    <SkipPreviousIcon className={isWide ? "mani-button-wide" : "mani-button"}></SkipPreviousIcon>
                </IconButton>
                <IconButton
                    onClick={() => {
                        play();
                        if (hudaIndex < newHudaList.length - 1) {
                            if (hudaIndex == maxIndex) {
                                setMaxIndex(maxIndex + 1);
                            }
                            setHudaIndex(hudaIndex + 1);
                        }
                        repeatRef.current = 0;
                        setIsPlaying(true);
                    }}
                >
                    <SkipNextIcon className={isWide ? "mani-button-wide" : "mani-button"}></SkipNextIcon>
                </IconButton>
            </div>

            <CustomBottomSheet
                repeatRef={repeatRef}
                maxIndex={maxIndex}
                setMaxIndex={setMaxIndex}
                newHudaList={newHudaList}
                isOpen={isOpen}
                setOpenBottomSheet={setOpen}
                setHudaIndex={setHudaIndex}
                hudaIndex={hudaIndex}
            ></CustomBottomSheet>
            <CustomBottomSetting
                reSettingKaruta={reSettingKaruta}
                customSetting={customSetting}
                setCustomSetting={setCustomSetting}
                isOpen={isSettingOpen}
                setOpen={setSettingOpen}
                play={play}
                customHudaList={customHudaList}
            ></CustomBottomSetting>
            <React.Fragment>
                <Dialog
                    onClick={() => {
                        handleModalClose();
                    }}
                    // keepMounted
                    style={{
                        width: isWide ? "36%" : "95%",
                        margin: "auto",
                    }}
                    open={false}
                    onClose={handleModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogActions>
                        <Button onClick={handleModalClose}>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogActions>
                    <DialogContent style={{ display: "flex", flexDirection: "column" }}>
                        <span>スタートボタンおしてください（仮）</span>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        </div>
    );
};

export default PlayPageAuto;
